import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#121212]">
        <div className="text-[#A1A1AA] font-mono text-sm">CARGANDO...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
};
